import { Grid, makeStyles } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";
import Staff from "../../actions/staff";
import Roles from "../../actions/role";
import {
  Autocomplete,
  CircularProgress,
  FormHelperText,
  MenuItem,
} from "@mui/material";
import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";
import produce from "immer";
import TextField from "@material-ui/core/TextField";
import CheckIcon from "@mui/icons-material/Check";

const initialFValues = {
  fullName: "",
  phoneNo: "",
  roles: "",
  email: "",
  editing: false,
};

const useStyles = makeStyles((theme) => ({
  icon: {
    borderRadius: "50%",
    height: "40px",
    width: "40px",
  },
}));

const AddStff = ({
  NotifyMessage,
  setOpenPopup,
  recordForEdit,
  setStaffs,
  getAllStaffs,
  edite,
}) => {
  const classes = useStyles();
  const { addStaff, updateStaff } = Staff();
  const [roles, setRoles] = useState([]);
  const { viewAllRoles } = Roles();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [roleError, setRoleError] = useState(false);
 const firstFieldRef = useRef(null);
  useEffect(() => {
    if (firstFieldRef.current) {
      firstFieldRef.current.focus();
    }
  }, []);
  const validate = (fieldValues = values) => {
    const temp = { ...errors };
    const regexEmail =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if ("fullName" in fieldValues)
      temp.fullName =
        fieldValues.fullName.length != 0 ? "" : "This field is required.";
    if ("phoneNo" in fieldValues)
      temp.phoneNo =
        fieldValues.phoneNo.length != 0 ? "" : "This field is required.";
    if ("email" in fieldValues) {
      if (fieldValues?.email?.length !== 0) {
        temp.email = regexEmail.test(fieldValues.email.toString().toLowerCase())
          ? ""
          : "Email is not valid.";
      }
    }

    setErrors({
      ...temp,
    });
    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };

  const { values, errors, setValues, handleInputChange, setErrors, resetForm } =
    useForm(initialFValues, true, validate);

  useEffect(() => {
    getAllRoles();
  }, []);

  useEffect(() => {
    if (recordForEdit !== null) {
      const initialSelectedOptions = recordForEdit.staffRoles
        .map((staffRole) => roles.find((role) => role.id === staffRole.role.id))
        .filter((role) => role); // Filter out any undefined results

      setSelectedOptions(initialSelectedOptions);
      setValues({
        ...recordForEdit,
        roles: initialSelectedOptions.map((role) => role.id), // Store IDs only in values
      });
    }
  }, [recordForEdit, roles]);

  const getAllRoles = () => {
    viewAllRoles().then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.roles) {
        setRoles(data.roles);
      }
    });
  };

  const handleChange = (event, newValue) => {
    setSelectedOptions(newValue);
    setValues({
      ...values,
      roles: newValue.map((option) => option.id),
    });
  };

  const handleSubmit = () => {
    if (validate()) {
      setValues({ ...values, submitting: true });
      if (edite === false) {
        delete values.logginError;
        delete values.editing;
        addStaff(values).then((data) => {
          if (data.err) {
            setValues({ ...values, submitting: false });
            NotifyMessage({
              message: data.err,
              type: "error",
            });
          } else if (data.staff) {
            NotifyMessage({
              message: data.staff.password,
              type: "success",
            });
            setOpenPopup(false);
            getAllStaffs()
            resetForm();
          }
        });
      } else {
        delete values.logginError;
        delete values.editing;
        updateStaff(values, values.id).then((data) => {
          if (data.err) {
            setValues({ ...values, submitting: false });
            NotifyMessage({
              message: data.err,
              type: "error",
            });
          } else {
            NotifyMessage({
              message: "Staff successfully updated",
              type: "success",
            });
            setOpenPopup(false);
            resetForm();
            getAllStaffs()
          }
        });
      }
    }
  };

  const handleAddClick = (e) => {
    e.preventDefault();

    if (selectedOptions.length === 0) {
      setRoleError(true);
    } else {
      setRoleError(false);
      handleSubmit();
    }
  };

  return (
    <Form onSubmit={handleAddClick}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="fullName"
            label="Full Name"
            value={values.fullName}
            onChange={handleInputChange}
            error={errors.fullName}
            inputRef={firstFieldRef}

          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="email"
            label="Email"
            value={values.email}
            onChange={handleInputChange}
            error={errors.email}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="phoneNo"
            label="Phone Number"
            value={values.phoneNo}
            onChange={handleInputChange}
            error={errors.phoneNo}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <>
            <Autocomplete
              multiple
              options={roles}
              getOptionLabel={(option) => option.name}
              disableCloseOnSelect
              onChange={handleChange}
              value={selectedOptions} // Use 'value' instead of 'defaultValue'
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Select Roles"
                />
              )}
              renderOption={(props, option, { selected }) => (
                <MenuItem
                  {...props}
                  key={option.id}
                  value={option.id}
                  sx={{ justifyContent: "space-between" }}
                >
                  {option.name}
                  {selected ? <CheckIcon color="info" /> : null}
                </MenuItem>
              )}
            />
            {roleError && (
              <FormHelperText error>
                Please select at least one role
              </FormHelperText>
            )}
          </>
        </Grid>
        <Grid item xs={12} md={6}>
          <div>
            <Controls.Button
              disabled={values.submitting ? true : false}
              text={
                edite == true
                  ? values.submitting
                    ? "Editing..."
                    : "Done"
                  : values.submitting
                  ? "Adding..."
                  : "Add"
              }
              variant="contained"
              className="Button"
              type="submit"
            />
            <Controls.Button
              text={"Cancel"}
              variant="contained"
              className="Button"
              onClick={() => {
                setOpenPopup(false);
              }}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default AddStff;
